module.exports = __webpack_public_path__ + "background23.jpg?cf18796dfcd43f17f574e2bf11af05af";